import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_u_header = _resolveComponent("u-header")!
  const _component_app_main = _resolveComponent("app-main")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["g-container-layout", _ctx.classObj])
  }, [
    _createVNode(_component_sidebar, { class: "sidebar-container" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_u_header),
      _createVNode(_component_app_main)
    ])
  ], 2))
}